import { render, staticRenderFns } from "./verifyCard.vue?vue&type=template&id=bb973b72&scoped=true"
import script from "./verifyCard.vue?vue&type=script&lang=js"
export * from "./verifyCard.vue?vue&type=script&lang=js"
import style0 from "./verifyCard.vue?vue&type=style&index=0&id=bb973b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb973b72",
  null
  
)

export default component.exports